
// @ts-ignore
import LoaderMobile from './loaderMobile.ts';
export default LoaderMobile;
